import PublicHeader from '@/components/layout/PublicHeader';
import LandingFooter from '@/components/landing/LandingFooter';
import { usePageSEO } from '@/hooks/usePageSEO';
import { useTranslation } from 'react-i18next';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { FaYoutube, FaInstagram, FaTiktok } from 'react-icons/fa';

export default function ContactPage() {
  const { t } = useTranslation();

  usePageSEO('contact', { canonicalPath: '/contact', breadcrumbs: [{ name: 'Contact' }] });

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 font-sans">
      <PublicHeader />

      <div className="pt-28" />

      <main className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-6">
          {t('contact.heading')}
        </h1>

        <p className="text-gray-700 dark:text-gray-300 mb-10">{t('contact.intro')}</p>

        <div className="space-y-6">
          <a
            href="mailto:support@planwise.social"
            className="flex items-center gap-3 p-4 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-primary-400 dark:hover:border-primary-500 transition-colors"
          >
            <EnvelopeIcon className="h-6 w-6 text-primary-600 dark:text-primary-400 flex-shrink-0" />
            <div>
              <div className="font-medium text-gray-900 dark:text-white">{t('contact.emailLabel')}</div>
              <div className="text-sm text-gray-500 dark:text-gray-400">support@planwise.social</div>
            </div>
          </a>

          <div>
            <p className="text-sm font-medium text-gray-900 dark:text-white mb-3">{t('contact.socialLabel')}</p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.youtube.com/@PlanWiseSocial"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 hover:bg-red-600 text-gray-500 dark:text-gray-400 hover:text-white transition-all"
                aria-label={t('board.platforms.youtube')}
              >
                <FaYoutube className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/planwise.social/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-500 text-gray-500 dark:text-gray-400 hover:text-white transition-all"
                aria-label={t('board.platforms.instagram')}
              >
                <FaInstagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.tiktok.com/@planwise.social"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 hover:bg-black text-gray-500 dark:text-gray-400 hover:text-white transition-all"
                aria-label={t('board.platforms.tiktok')}
              >
                <FaTiktok className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </main>

      <LandingFooter />
    </div>
  );
}
